import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-64ea4209")
const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  key: 3,
  class: "display"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", null, "Account", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "_a" }, null, -1)
const _hoisted_5 = { class: "_grid" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "You are signed out", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "_a" }, null, -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Ripple = _resolveComponent("Ripple")!
  const _component_MovingIcon = _resolveComponent("MovingIcon")!
  const _component_IconButton = _resolveComponent("IconButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: "account",
    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.open=true))
  }, [
    (_ctx.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "_cover",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.open=false), ["stop"]))
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Ripple),
    (_ctx.player.unset)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_MovingIcon, {
            name: "loader_spinner",
            autoplay: true,
            loop: true
          })
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass({
      icon:true, 
      _img:true, 
      [_ctx.player.avatar]:true
    }),
          style: _normalizeStyle(`background-image: ${_ctx.player.picture?'url('+_ctx.player.picture+')':''}`)
        }, null, 6)),
    (_ctx.open)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          (_ctx.player.email)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("p", null, _toDisplayString(_ctx.player.name), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.player.email), 1),
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_IconButton, {
                    text: "Sign out",
                    icon: _ctx.logoutTriggered?'loader_spinner':_ctx.logoutSuccess?'tick':_ctx.logoutError?'cross':'',
                    loop: false,
                    autoplay: true,
                    colored: true,
                    hex: "#FFFFFF",
                    onClick: _ctx.signout
                  }, null, 8, ["icon", "onClick"]),
                  _createVNode(_component_IconButton, {
                    text: "My account",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({path:'/account'})))
                  })
                ])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_6,
                _hoisted_7,
                _createVNode(_component_IconButton, {
                  icon: "user",
                  type: "svg",
                  text: "Account and login",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({path:'/account'})))
                })
              ], 64))
        ]))
      : _createCommentVNode("", true)
  ]))
}